<template>
  <div class="horizontal-card-clean" v-if="asset">
    <router-link :to="url">
      <lazy-image
        type="horizontal"
        :src="asset.screenshot.small"
        :alt="asset.title"
        :title="asset.title"
      />
    </router-link>
  </div>
</template>

<script>
import LazyImage from "@/components/utils/LaziImage.vue";

export default {
  name: "HorizontalCardClean",
  components: { LazyImage },
  props: {
    asset: Object,
    default: function () {
      return null;
    },
  },
  computed: {
    url() {
      let url = this.$t("movie_route", { slug: this.asset.slug });
      if (this.asset.type === "series") {
        url = this.$t("serie_route", { slug: this.asset.slug });
      }
      return url;
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";
.horizontal-card-clean {
  *,
  *:hover {
    text-decoration: none;
  }
  .title {
    color: #ffffff;
  }
  cursor: pointer;
  margin: 0 0 0 1em;
  padding: 1em 0.5em;
  transition: margin 0.4s;

  img {
    border-radius: 16px;
    width: 100%;
  }
}
</style>
